(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["blog-tag-filter"]) return;
  try {
    
  //Hide Empty Filter Blocks
  $('.article-filters .filter-block').each(function () {
  	// console.log($(this).children('ul').children('li').length);
    if ($(this).children('ul').children('li').length < 1) {
      $(this).hide();
    }
  });

  //accordion code
  var acc = document.getElementsByClassName("accordion");
  var openInit = document.getElementsByClassName("open");
  var i;

  for (i = 0; i < acc.length; i++) {
    acc[i].addEventListener("click", function() {
      // for(j = 0; j < acc.length; j++) {
      //   acc[j].nextElementSibling.style.maxHeight = null;
      //   acc[j].classList.remove('active');
      // }
      this.classList.toggle("active");
      var panel = this.nextElementSibling;
      if (panel.classList.contains("open")) {
        panel.classList.toggle("open");
        panel.style.maxHeight = null;
      } else {
        panel.style.maxHeight = panel.scrollHeight + "px";
        panel.classList.toggle("open");
      }
    });
  }

  for (i = 0; i < openInit.length; i++) {
    openInit[i].style.maxHeight = openInit[i].scrollHeight + "px";
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
//console.log('foo')
var lastNoteVal = '';
var saveCartNoteTimer = null;
$('#CartSpecialInstructions').on('change keyup paste mouseup', function(e) {
  var noteValue = $(this).val();

  if (noteValue != lastNoteVal) {
    lastNoteVal = noteValue;
    //CartJS.setNote($(this).val());
    window.clearTimeout(saveCartNoteTimer);
    saveCartNoteTimer = window.setTimeout(function() {
      jQuery.ajax({
        type: 'POST',
        url: window.Shopify.routes.root + 'cart/update.js',
        data: { note: noteValue },
        dataType: 'json'
      });
      console.log('Note set!');
    }, 350);

    if (!CartJS.getAttribute("Note Subject") && noteValue != "") {
      CartJS.setAttribute("Note Subject", $('#whats-the-subject-of-your-note').val());
      console.log('no note subject, setting to: ', $('#whats-the-subject-of-your-note').val())
    }
  }
})
$(document).on('change', '#what-type-of-gardener-are-you', function() {
  CartJS.setAttribute('Customer Type', $(this).val());
  console.log('Attribute set!');
})
$(document).on('change', '#whats-the-subject-of-your-note', function() {
  CartJS.setAttribute("Note Subject", $(this).val());
  console.log('Note subject set!');
})
const noteTextArea = document.querySelector("textarea#CartSpecialInstructions");
const noteCounters = document.querySelector(".note-counter");
const noteAlerts = document.querySelector(".note-alert");
const updateNoteCounter = () => {
  const target = noteTextArea;
  const maxLength = target.getAttribute("maxlength");
  const currentLength = target.value.length;
  if (currentLength >= maxLength) {
    noteAlerts.innerHTML = "You have reached the maximum number of characters.";
  } else {
    noteAlerts.innerHTML = "";
  }
  noteCounters.innerHTML = `${currentLength}/${maxLength}`;
}
function updateNoteCounterOnLoad() {
  const target = noteTextArea;
  const maxLength = target.getAttribute("maxlength");
  const currentLength = target.value.length;
  if (currentLength >= maxLength) {
    noteAlerts.innerHTML = "You have reached the maximum number of characters.";
  } else {
    noteAlerts.innerHTML = "";
  }
  noteCounters.innerHTML = `${currentLength}/${maxLength}`;
}
noteTextArea.addEventListener("input", updateNoteCounter);
$(document).ready(function() {
  updateNoteCounterOnLoad();
})
const clearCartBtn = document.querySelector('#clearcart')
clearCartBtn.addEventListener("click", function(e) {
  if (confirm("Are you sure you want to remove everything from your cart?") == true) {
    $(document).trigger('cart.drawerClearRequested');
  }
})

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-tag-filter"]) return;
  try {
    
  //Hide Empty Filter Blocks
  $('.catalog-filters .filter-block').each(function () {
    if ($(this).children('ul').children('li').length < 1) {
      $(this).hide();
    }
  });

  //accordion code
  var acc = document.getElementsByClassName("accordion");
  var openInit = document.getElementsByClassName("open");
  var i;

  for (i = 0; i < acc.length; i++) {
    acc[i].addEventListener("click", function() {
      // for(j = 0; j < acc.length; j++) {
      //   acc[j].nextElementSibling.style.maxHeight = null;
      //   acc[j].classList.remove('active');
      // }
      this.classList.toggle("active");
      var panel = this.nextElementSibling;
      if (panel.classList.contains("open")) {
        panel.classList.toggle("open");
        panel.style.maxHeight = null;
      } else {
        panel.style.maxHeight = panel.scrollHeight + "px";
        panel.classList.toggle("open");
      }
    });
  }

  for (i = 0; i < openInit.length; i++) {
    openInit[i].style.maxHeight = openInit[i].scrollHeight + "px";
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
class LocalizationForm extends HTMLElement {
constructor() {
  super();
  this.elements = {
    input: this.querySelector('input[name="language_code"], input[name="country_code"]'),
    button: this.querySelector('button'),
    panel: this.querySelector('ul'),
  };
  this.elements.button.addEventListener('click', this.openSelector.bind(this));
  this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
  this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

  this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
}

hidePanel() {
  this.elements.button.setAttribute('aria-expanded', 'false');
  this.elements.panel.setAttribute('hidden', true);
}

onContainerKeyUp(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  this.hidePanel();
  this.elements.button.focus();
}

onItemClick(event) {
  event.preventDefault();
  const form = this.querySelector('form');
  this.elements.input.value = event.currentTarget.dataset.value;
  if (form) form.submit();
}

openSelector() {
  this.elements.button.focus();
  this.elements.panel.toggleAttribute('hidden');
  this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
}

closeSelector(event) {
  const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
  if (event.relatedTarget === null || shouldClose) {
    this.hidePanel();
  }
}
}

customElements.define('localization-form', LocalizationForm);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-menu-best-sellers"]) return;
  try {
    
  const bestSellerLinks = document.querySelectorAll('.best-seller-link');
  const bestSellerPlaceholder = document.getElementById('bestseller-img');
  const bestSellerImg = document.getElementById('bs-img');
  const bestSellerTitle = document.getElementById('bs-title');
  const bestSellerLink = document.getElementById('bs-link');
  for (let link of bestSellerLinks) {
    link.addEventListener('mouseover', function(e) {
      let prodImg = link.dataset.imgUrl;
      let prodTitle = link.textContent.split('-')[0];
      let prodUrl = link.dataset.prodUrl;
      // console.log(prodImg);
      // console.log(prodTitle);
      bestSellerImg.src = prodImg;
      bestSellerTitle.textContent = prodTitle;
      bestSellerLink.href = prodUrl;
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
//COUNTDOWN TIMER
function getTimeRemaining(endtime) {
  const total = Date.parse(endtime) - Date.parse(new Date());
  const seconds = Math.floor((total / 1000) % 60);
  const minutes = Math.floor((total / 1000 / 60) % 60);
  const hours = Math.floor((total / (1000 * 60 * 60)) % 24);
  const days = Math.floor(total / (1000 * 60 * 60 * 24));

  return {
    total,
    days,
    hours,
    minutes,
    seconds
  };
}

function initializeClock(id, endtime) {
  console.log("initilizing timer with endtime: ", endtime);
  const clock = document.getElementById(id);
  clock.style.display = 'block';
  const daysSpan = clock.querySelector('.days');
  const hoursSpan = clock.querySelector('.hours');
  const minutesSpan = clock.querySelector('.minutes');
  const secondsSpan = clock.querySelector('.seconds');

  function updateClock() {
    const t = getTimeRemaining(endtime);

    daysSpan.innerHTML = t.days + "d ";
    hoursSpan.innerHTML = ('0' + t.hours).slice(-2) + "h ";
    minutesSpan.innerHTML = ('0' + t.minutes).slice(-2) + "m ";
    secondsSpan.innerHTML = ('0' + t.seconds).slice(-2) + "s ";

    if (t.total <= 0) {
      clearInterval(timeinterval);
    }
  }

  updateClock();
  const timeinterval = setInterval(updateClock, 1000);
}

//const deadline = 'November 29 2021 23:59:59 GMT-0800';
//initializeClock('countdown-bar', deadline);
const schedule = [
    ['November 25 2022 00:00:00 GMT-0800', 'November 28 2022 23:59:59 GMT-0800']
];
// schedule.forEach(([startDate, endDate]) => {
//   // put dates in milliseconds for easy comparisons
//   const startMs = Date.parse(startDate);
//   const endMs = Date.parse(endDate);
//   const currentMs = Date.parse(new Date());

//   // if current date is between start and end dates, display clock
//   if (endMs > currentMs && currentMs >= startMs ) {
//     initializeClock('countdown-bar', endDate);
//     document.body.classList.add("countdown-bar");
//   }
// });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header_full"]) return;
  try {
    
$(".menu-body .recent-posts .owl-carousel").owlCarousel ({
  nav : true,
  slideSpeed : 300,
  paginationSpeed : 400,
  dots: true,
  items: 4,
  margin: 10,
  loop: true,
  navText : ["<i class='fa fa-chevron-left'></i>","<i class='fa fa-chevron-right'></i>"]
})

$(".menu-body .blog-category-bar .owl-carousel").owlCarousel ({
  nav : true, // Show next and prev buttons
  dots : true,
  slideSpeed : 300,
  paginationSpeed : 400,
  items: 4,
  margin: 10,
  loop: true,
  navText : ["<i class='fa fa-chevron-left'></i>","<i class='fa fa-chevron-right'></i>"]
})

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lightbox-image-row"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function (event) {
    const trigger = event.target.closest('[data-lightbox-image-src]');
    if (trigger) {
      const row = trigger.closest('.lightbox-image-row');
      const dialog = row && row.querySelector('.lightbox-image-row__dialog');
      const image = dialog && dialog.querySelector('.lightbox-image-row__dialog-image');
      if (!dialog || !image) return;

      image.src = trigger.dataset.lightboxImageSrc;
      image.alt = trigger.dataset.lightboxImageAlt || '';
      if (typeof dialog.showModal === 'function') {
        dialog.showModal();
      } else {
        window.open(image.src, '_blank', 'noopener');
      }
      return;
    }

    const closeButton = event.target.closest('[data-lightbox-close]');
    if (closeButton) {
      closeButton.closest('dialog').close();
      return;
    }

    if (event.target.matches('.lightbox-image-row__dialog')) {
      event.target.close();
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations-findify"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'product-recommendations'
  var productRecommendationsSection = document.querySelector(".product-recommendations");
  if (productRecommendationsSection === null) { return; }
  // Read product id from data attribute
  var productId = productRecommendationsSection.dataset.productId;
  // Read limit from data attribute
  var limit = productRecommendationsSection.dataset.limit;
  // Build request URL
  var requestUrl = "/recommendations/products?section_id=product-recommendations&limit="+limit+"&product_id="+productId;
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", requestUrl);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.parentElement.innerHTML = container.querySelector(".product-recommendations").innerHTML;
      initSwiper();
    }
  };
  request.send();
};
// If your section has theme settings, the theme editor
// reloads the section as you edit those settings. When that happens, the
// recommendations need to be fetched again.
// See https://help.shopify.com/en/themes/development/sections/integration-with-theme-editor
document.addEventListener("shopify:section:load", function(event) {
  if (event.detail.sectionId === "product-recommendations") {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations-shopify"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'product-recommendations'
  var productRecommendationsSection = document.querySelector(".product-recommendations");
  if (productRecommendationsSection === null) { return; }
  // Read product id from data attribute
  var productId = productRecommendationsSection.dataset.productId;
  // Read limit from data attribute
  var limit = productRecommendationsSection.dataset.limit;
  // Build request URL
  var requestUrl = "/recommendations/products?section_id=product-recommendations&limit="+limit+"&product_id="+productId;
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", requestUrl);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.parentElement.innerHTML = container.querySelector(".product-recommendations").innerHTML;
      initSwiper();
    }
  };
  request.send();
};
// If your section has theme settings, the theme editor
// reloads the section as you edit those settings. When that happens, the
// recommendations need to be fetched again.
// See https://help.shopify.com/en/themes/development/sections/integration-with-theme-editor
document.addEventListener("shopify:section:load", function(event) {
  if (event.detail.sectionId === "product-recommendations") {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  //NEW - TAG BASED TIERED DISCOUNTS
  //if hidden discount tiers html is present, put values into associative array discountTiers
  if ($('#bulk-discount-tiers').length) {
    var discountTiersRaw = $('#bulk-discount-tiers').text();
    var discountType = '%';
    if (discountTiersRaw.includes('$')) {
      discountTiersRaw = discountTiersRaw.replace(/[$]/gi, '');
      discountType = '$';
    } else if (discountTiersRaw.includes('%')) {
      discountTiersRaw = discountTiersRaw.replace(/[%]/gi, '');
      discountType = '%';
    }
    discountTiersRaw = discountTiersRaw.split(',');
    var discountTiers = [];
    var discount;
    $.each(discountTiersRaw, function (index, tier) {
      tierSplit = tier.split(':');
      quant = parseInt(tierSplit[0]);
      disc = parseInt(tierSplit[1]);
      discountTiers.push({ quantity: quant, discount: disc });
    });
  }
  //on quantity change...
  $('input.quantity').on('input', function () {
    //get quantity
    currQuantity = $(this).val();
    //if discounts found
    if (discountTiers) {
      $.each(discountTiers, function (index, tier) {
        if (currQuantity >= tier.quantity) {
          discount = tier.discount;
          if (discountType == '$') {
            console.log('$' + discount + ' off!');
          } else {
            console.log(discount + '% off!');
          }
          return false;
        } else {
          discount = false;
        }
      });
      if (!discount) {
        console.log('quantity too low for discount');
        if ($(this).closest('tr').find('.line-price span.orig-price').length) {
          $(this).closest('tr').find('.line-price span.discounted-price').remove();
          $(this).closest('tr').find('.line-price span.orig-price').unwrap().removeClass('orig-price');
        }
      }
    }

    if (discount) {
      //calculate discounted price
      if (discountType == '$') {
        //calculate $off amounts
        var origPrice = parseInt($(this).attr('data-price'));
        var linePrice = Math.ceil(origPrice - discount * 100);
        var linePriceFormatted = slate.Currency.formatMoney(linePrice, theme.moneyFormat);
        var lineTotal = currQuantity * origPrice - currQuantity * (discount * 100);
      } else {
        //calculate %off amounts
        var origPrice = parseInt($(this).attr('data-price'));
        var linePrice = Math.ceil(origPrice * (1 - discount / 100));
        var linePriceFormatted = slate.Currency.formatMoney(linePrice, theme.moneyFormat);
        var lineTotal = $(this).val() * origPrice * (1 - discount / 100);
      }
      var lineTotalFormatted = slate.Currency.formatMoney(lineTotal, theme.moneyFormat);
      var origTotalFormatted = slate.Currency.formatMoney($(this).val() * origPrice, theme.moneyFormat);
      console.log('orig total' + origTotalFormatted);
      //console.log("discounted price per unit: " + slate.Currency.formatMoney(linePrice, theme.moneyFormat));
      //console.log("discounted total line price: " + slate.Currency.formatMoney(lineTotal, theme.moneyFormat))
      // show discounted unit price and orig price if not shown already
      if ($(this).closest('tr').find('.line-price span.orig-price').length == 0) {
        $(this).closest('tr').find('.line-price span.money').addClass('orig-price');
        $(this).closest('tr').find('.line-price span.money').wrap('<s></s>');
        $(this).closest('tr').find('.line-price').append($(linePriceFormatted).addClass('discounted-price'));
        //do the same with line total
        $(this).parent().next('.line-total').html(origTotalFormatted);
        $(this).closest('tr').find('.line-total span.money').addClass('orig-price');
        $(this).closest('tr').find('.line-total span.money').wrap('<s></s>');
        $(this).closest('tr').find('.line-total').append($(lineTotalFormatted).addClass('discounted-price'));
      } else {
        // update discounted unit price and line total
        $(this)
          .closest('tr')
          .find('.line-price span.discounted-price')
          .replaceWith($(linePriceFormatted).addClass('discounted-price'));
        $(this)
          .closest('tr')
          .find('.line-total span.discounted-price')
          .replaceWith($(lineTotalFormatted).addClass('discounted-price'));
        $(this)
          .closest('tr')
          .find('.line-total span.orig-price')
          .replaceWith($(origTotalFormatted).addClass('orig-price'));
      }
    } else {
      //get original price
      var linePrice = parseInt($(this).attr('data-price'));
      //set line total
      var lineTotal = $(this).val() * linePrice;
      $(this).parent().next('.line-total').html(slate.Currency.formatMoney(lineTotal, theme.moneyFormat));
    }
    $(this).parent().next('.line-total').attr('data-total', lineTotal);
    var grandTotal = 0;
    $('.line-total').each(function () {
      if (parseInt($(this).attr('data-total')) > 0) {
        //grandTotal = grandTotal + parseFloat($(this).attr('data-total'));
        if ($('span.discounted-price', this).length) {
          var price = parseFloat(
            $('span.discounted-price', this).text().replace('$', '').replace('.', '').replace(',', '')
          );
        } else {
          var price = parseFloat($('span.money', this).text().replace('$', '').replace('.', '').replace(',', ''));
        }
        console.log('price is: ' + price);
        grandTotal = grandTotal + price;
      }
    });
    $('.add-to-cart-total').html(slate.Currency.formatMoney(grandTotal, theme.moneyFormat));
  });

  //helper function to round float up to two decimals to match Shopify scripts discount rounding
  function roundUp(num, precision) {
    precision = Math.pow(10, precision);
    return Math.ceil(num * precision) / precision;
  }

  } catch(e) { console.error(e); }
})();
})();
